"use strict";
/**
 * Novig's `marketType` → the shared coarse tier (`moneyline` | `spreads` |
 * `totals` | `props`), for the picker's chips and the order log alike. The list
 * is open-ended (`GET /v3/types/markets`), so an unknown type is `null` and each
 * caller chooses its fallback (ai/skills/add-novig-market-type.md).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.novigCoarseTier = novigCoarseTier;
const TIERS = {
    MONEY: "moneyline",
    FIRST_SET_MONEYLINE: "moneyline",
    SPREAD: "spreads",
    SET_SPREAD: "spreads",
    TOTAL: "totals",
    TOTAL_SETS: "totals",
};
function novigCoarseTier(marketType) {
    const key = marketType.toUpperCase();
    if (TIERS[key])
        return TIERS[key];
    if (key.includes("PROP") || key.startsWith("PLAYER_"))
        return "props";
    return null;
}
